// Single source of truth for PK Lake House content.
export const VRBO_URL = "https://www.vrbo.com/3591769";
export const VRBO_ID = "3591769";
export const DOMAIN = "pklakehouse.com";

export const PROPERTY = {
  name: "PK Lake House",
  tagline: "Waterfront with a private dock on Possum Kingdom Lake",
  location: "Graford, Texas",
  region: "Possum Kingdom Lake",
  bedrooms: 6,
  bathrooms: 6,
  sleeps: 18,
  rating: 9.8,
  reviewCount: 111,
  priceNote: "All fees included. No hidden fees.",
};

export const HERO_IMAGE = { src: "/property/photo-3.jpg", alt: "PK Lake House stone exterior overlooking Possum Kingdom Lake in Graford, Texas" };

export const CHAPTERS = [
  {
    num: "01",
    kicker: "The Water's Edge",
    title: "A private stretch of Possum Kingdom Lake",
    body: "Wake to still water and limestone bluffs. Your own dock steps down to the lake, where the boats wait and the afternoons stretch long. This is waterfront the way it should be — quiet, wide open, and entirely yours.",
    image: { src: "/property/photo-5.jpg", alt: "Private dock and panoramic view of Possum Kingdom Lake at PK Lake House" },
  },
];

export const GALLERY = [
  { src: "/property/photo-1.jpg", alt: "Covered lakeside patio with stone fireplace and full outdoor kitchen at PK Lake House", label: "Outdoor Living", span: "lg:col-span-7 lg:row-span-2" },
  { src: "/property/photo-2.jpg", alt: "Great room with soaring vaulted ceilings and a towering stone fireplace", label: "The Great Room", span: "lg:col-span-5" },
  { src: "/property/photo-4.jpg", alt: "Swimming pool and hot tub on a flagstone deck overlooking Possum Kingdom Lake", label: "Pool & Hot Tub", span: "lg:col-span-5" },
];

export const SPECS = [
  { label: "Bedrooms", value: "6" },
  { label: "Bathrooms", value: "6" },
  { label: "Sleeps", value: "18" },
  { label: "Rating", value: "9.8" },
];

export const AMENITIES = [
  "Private Boat Dock", "Direct Waterfront", "Swimming Pool", "Hot Tub",
  "Outdoor Kitchen & Grill", "Outdoor Stone Fireplace", "Pro-Grade Kitchen",
  "Double Island", "Air Conditioning", "Washer & Dryer", "High-Speed WiFi",
  "Ample Parking", "Oversized Patio", "Open-Concept Great Room",
];

export const MARQUEE = [
  "Possum Kingdom Lake",
  "Luxury Waterfront",
  "Sleeps 18",
  "Private Dock",
  "No Hidden Fees",
  "Graford, Texas",
];
